// Equivalente client-side di apply_field_filters (backend/crud/utils.py), per le pagine
// che filtrano in memoria sui dati gia' caricati invece di interrogare il server
// (es. Promozioni, CodiciSconto): Filter.js produce sempre lo stesso formato di valore
// (array per la checklist, null per "N/A", oggetto { __advanced } per le modalita'
// avanzate) a prescindere da come poi viene consumato, quindi serve un filterFn
// TanStack che sappia interpretarlo qui, dove non c'e' un'API a tradurlo in query SQL.
export function checklistFilterFn(row, columnId, filterValue) {
  const valoreRiga = row.getValue(columnId);

  if (filterValue === null) {
    return valoreRiga === null || valoreRiga === undefined || valoreRiga === '';
  }

  if (filterValue && typeof filterValue === 'object' && !Array.isArray(filterValue) && filterValue.__advanced) {
    const testo = String(valoreRiga ?? '').toLowerCase();
    if (filterValue.__advanced === 'not_empty') {
      return testo !== '';
    }
    if (filterValue.__advanced === 'contains') {
      return testo.includes(String(filterValue.text || '').toLowerCase());
    }
    if (filterValue.__advanced === 'not_contains') {
      return !testo.includes(String(filterValue.text || '').toLowerCase());
    }
    return true;
  }

  if (Array.isArray(filterValue)) {
    if (filterValue.length === 0) return true;
    return filterValue.some(v => String(v) === String(valoreRiga));
  }

  return true;
}

// Equivalente client-side delle varianti 'date-range'/'number-range' di Filter.js:
// stesso formato { from, to } (eventualmente solo uno dei due) usato lato server da
// apply_field_filters/buildServerFilters. 'to' su una data viene esteso a fine
// giornata (23:59:59) cosi' il giorno finale selezionato resta incluso.
export function rangeFilterFn(row, columnId, filterValue) {
  if (!filterValue || typeof filterValue !== 'object') return true;
  const { from, to } = filterValue;
  const valoreRiga = row.getValue(columnId);
  if (valoreRiga === null || valoreRiga === undefined || valoreRiga === '') return false;

  const isDateLike = (v) => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}/.test(v);

  if (isDateLike(from) || isDateLike(to) || isDateLike(valoreRiga)) {
    const value = new Date(valoreRiga).getTime();
    if (from && value < new Date(from).getTime()) return false;
    if (to) {
      const toFineGiornata = to.length === 10 ? `${to}T23:59:59.999` : to;
      if (value > new Date(toFineGiornata).getTime()) return false;
    }
    return true;
  }

  const value = Number(valoreRiga);
  if (from !== undefined && value < Number(from)) return false;
  if (to !== undefined && value > Number(to)) return false;
  return true;
}
